// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── page root ──────────────────────────────────────────── */
.lp-root {
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  height: 100vh;
  width: 100vw;
  background: #f0f4f8;
  padding: 0;
  box-sizing: border-box;
  font-family: "Inter", "Segoe UI", sans-serif;
}

/* ── outer card wrapper ─────────────────────────────────── */
.login-card-wrapper-section {
  display: grid;
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  border-radius: 28px;
  background-color: #ffffff;
  box-shadow: 0 12px 60px rgba(10, 30, 80, 0.10);
  margin: 12px;
  height: calc(100vh - 24px);
  width: calc(100vw - 24px);
}

@media (min-width: 1024px) {
  .login-card-wrapper-section {
    grid-template-columns: 1.04fr 0.96fr;
    border-radius: 28px;
  }
}

/* ── Pallet logo — top right ────────────────────────────── */
.lp-pallet-logo-wrap {
  position: absolute;
  top: 20px;
  right: 24px;
  z-index: 20;
}

.lp-pallet-logo {
  height: 160px;
  width: auto;
  object-fit: contain;
}

/* ── left panel ─────────────────────────────────────────── */
.lp-left {
  display: none;
  position: relative;
  height: 100%;
  overflow: hidden;
  border-right: 1px solid #e8edf3;
}

@media (min-width: 1024px) {
  .lp-left {
    display: block;
  }
}

/* ── carousel ───────────────────────────────────────────── */
.lp-carousel {
  position: absolute;
  inset: 0;
}

.lp-slide {
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 0.9s cubic-bezier(0.4, 0, 0.2, 1);
}

.lp-slide.active {
  opacity: 1;
}

.lp-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* ── dot indicators ─────────────────────────────────────── */
.lp-dots {
  position: absolute;
  bottom: 1.5rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
  z-index: 10;
}

.lp-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  transition: background 0.3s, transform 0.3s;
  cursor: pointer;
  border: none;
  padding: 0;
}

.lp-dot.active {
  background: #fff;
  transform: scale(1.35);
}

/* ── right panel ────────────────────────────────────────── */
.lp-right {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 20px;
  box-sizing: border-box;
}

@media (min-width: 640px) {
  .lp-right {
    padding: 28px;
  }
}

@media (min-width: 1024px) {
  .lp-right {
    padding: 32px;
  }
}

@media (min-width: 1280px) {
  .lp-right {
    padding: 40px;
  }
}

/* ── form card — no nested card, just a max-width container ─ */
.lp-form-card {
  width: 100%;
  max-width: 520px;
  padding: 0;
  color: #020617;
  box-sizing: border-box;
}

/* ── badge ──────────────────────────────────────────────── */
.lp-badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border-radius: 9999px;
  border: 1px solid #dbeafe;
  background-color: #eff6ff;
  padding: 5px 14px 5px 8px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.22em;
  color: #2a71ff;
}

.lp-badge-icon {
  width: 22px;
  height: 22px;
  object-fit: contain;
  flex-shrink: 0;
}

/* ── heading ────────────────────────────────────────────── */
.lp-heading {
  margin: 12px 0 0 0;
  font-size: 1.875rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  color: #020617;
  display: flex;
  justify-content: space-between;
}

/* ── info card ──────────────────────────────────────────── */
.lp-info-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  border-radius: 26px;
  border: 1px solid #dbeafe;
  background: linear-gradient(180deg, #eff6ff 0%, #ffffff 100%);
  padding: 16px;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.1),
    0 1px 2px -1px rgba(0, 0, 0, 0.1);
  /* margin-top: 32px; */
  margin-bottom: 20px;
}

.lp-info-icon {
  display: flex;
  height: 48px;
  width: 48px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background-color: #ffffff;
  color: #2a71ff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.lp-info-brand {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  color: #2a71ff;
  margin: 0 0 8px 0;
}

.lp-info-desc {
  font-size: 14px;
  line-height: 1.625;
  color: #475569;
  margin: 0;
}

/* ── idle logout banner ─────────────────────────────────── */
.lp-idle-banner {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  background: #eef3ff;
  border: 1px solid #c5d4f0;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 18px;
  font-size: 12px;
  color: #3b63b8;
}

.lp-idle-icon {
  flex-shrink: 0;
  font-size: 16px !important;
  margin-top: 1px;
}

/* ── form ───────────────────────────────────────────────── */
.lp-form {
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  gap: 0;
}

/* ── field labels ───────────────────────────────────────── */
.lp-field-label {
  display: block;
  margin-bottom: 8px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  color: #94a3b8;
}

/* ── mobile input wrapper ───────────────────────────────── */
.lp-input-wrap {
  display: flex;
  align-items: stretch;
  gap: 0;
  border-radius: 24px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  padding: 0 16px 0 0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
  transition: border-color 0.15s, box-shadow 0.15s;
  overflow: visible;
}

.lp-input-wrap:focus-within {
  border-color: #2a71ff;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

.lp-input-wrap .lp-input {
  padding: 12px 0 12px 10px;
  align-self: center;
}

.lp-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  padding: 4px 0;
  height: 30px;
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
  min-width: 0;
}

.lp-input::placeholder {
  color: #94a3b8;
  font-weight: 400;
}

/* hide number spinners */
.lp-input::-webkit-outer-spin-button,
.lp-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.lp-input[type="number"] {
  -moz-appearance: textfield;
}

/* ── PIN input (full-width, no icon wrapper) ────────────── */
.lp-pin-wrap {
  display: flex;
  align-items: center;
  border-radius: 24px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  padding: 0 16px;
  height: 56px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  margin-bottom: 8px;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
}

.lp-pin-wrap:focus-within {
  border-color: #2a71ff;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

.lp-eye-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: #94a3b8;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

/* ── forgot pin ─────────────────────────────────────────── */
.lp-forgot {
  margin: 4px 0 20px 0;
}

.lp-forgot span {
  font-size: 14px;
  font-weight: 700;
  color: #2a71ff;
  cursor: pointer;
  transition: color 0.15s;
}

.lp-forgot span:hover {
  color: #155eef;
}

/* ── submit button ──────────────────────────────────────── */
.lp-submit-btn {
  width: 100%;
  height: 56px;
  background: #2a71ff;
  border: none;
  border-radius: 24px;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 22px 50px rgba(42, 113, 255, 0.35);
  transition:
    background 0.15s,
    opacity 0.15s;
}

.lp-submit-btn:hover:not(:disabled) {
  background: #155eef;
}

.lp-submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* ── reset pin panel ────────────────────────────────────── */
.lp-back-btn {
  /* Flexbox layout */
  display: flex;

  /* Sizing */
  height: 2.75rem; /* 44px */
  width: 2.75rem; /* 44px */

  /* Flex alignment */
  align-items: center;
  justify-content: center;

  /* Border radius */
  border-radius: 1rem; /* 16px - rounded-2xl */

  /* Border */
  border: 1px solid #e2e8f0; /* slate-200 */

  /* Background */
  background-color: #ffffff; /* white */

  /* Text/icon color */
  color: #475569; /* slate-600 */

  /* Transition */
  transition: all 0.2s ease-in-out;

  /* Remove default button styles */
  cursor: pointer;

  /* Optional: remove default focus outline (add custom one for accessibility) */
  outline: none;
}

.lp-back-btn:hover {
  border-color: #cbd5e1; /* slate-300 */
  color: #0f172a;
}

.lp-reset-heading {
  font-size: 1.6rem;
  font-weight: 800;
  color: #111827;
  margin: 0 0 20px 0;
}

/* ── loading gif ────────────────────────────────────────── */
.pos-gif-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #fff;
}

/* ── active button color ────────────────────────────────── */
.changeBtnColor {
  background-color: #2a71ff;
}

.move-back-button {
  display: flex;
  height: 2.75rem;
  width: 2.75rem;
  align-items: center;
  justify-content: center;
  border-radius: 9999px; /* rounded-full */
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  color: #475569;
  transition: all 0.2s ease-in-out;
}

.move-back-button:hover {
  border-color: #cbd5e1;
  color: #0f172a;
}

/* ── download section ───────────────────────────────────── */
.lp-download-section {
  margin-top: 20px;
  padding-top: 18px;
  border-top: 1px solid #f1f5f9;
}

.lp-download-title {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: #94a3b8;
  margin: 0 0 10px 0;
}

.lp-store-links {
  display: flex;
  gap: 10px;
}

.lp-store-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 16px;
  border-radius: 24px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #334155;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  transition: border-color 0.15s, background 0.15s, color 0.15s;
  white-space: nowrap;
}

.lp-store-img {
  width: 20px;
  height: 20px;
  object-fit: contain;
  border-radius: 5px;
  flex-shrink: 0;
}

.lp-store-btn:hover {
  border-color: #2a71ff;
  background: #eff6ff;
  color: #2a71ff;
}

/* ── register row ───────────────────────────────────────── */
.lp-register-row {
  margin-top: 14px;
  font-size: 13px;
  color: #64748b;
}

.lp-register-link {
  font-weight: 700;
  color: #2a71ff;
  text-decoration: none;
  transition: color 0.15s;
}

.lp-register-link:hover {
  color: #155eef;
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/LoginPage.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;EACE,aAAa;EACb,oBAAoB;EACpB,wBAAwB;EACxB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE;IACE,oCAAoC;IACpC,mBAAmB;EACrB;AACF;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,qDAAqD;AACvD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,2CAA2C;EAC3C,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,gEAAgE;AAChE;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,sBAAsB;AACxB;;AAEA,8DAA8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,6DAA6D;EAC7D,aAAa;EACb;;qCAEmC;EACnC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,MAAM;AACR;;AAEA,8DAA8D;AAC9D;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,oBAAoB;EACpB,MAAM;EACN,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;EACnB,gDAAgD;EAChD,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB;;oBAEkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gDAAgD;EAChD;;iBAEe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,aAAa;;EAEb,WAAW;EACX,eAAe,EAAE,SAAS;EAC1B,cAAc,EAAE,SAAS;;EAEzB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;;EAEvB,kBAAkB;EAClB,mBAAmB,EAAE,uBAAuB;;EAE5C,WAAW;EACX,yBAAyB,EAAE,cAAc;;EAEzC,eAAe;EACf,yBAAyB,EAAE,UAAU;;EAErC,oBAAoB;EACpB,cAAc,EAAE,cAAc;;EAE9B,eAAe;EACf,gCAAgC;;EAEhC,iCAAiC;EACjC,eAAe;;EAEf,8EAA8E;EAC9E,aAAa;AACf;;AAEA;EACE,qBAAqB,EAAE,cAAc;EACrC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB,EAAE,iBAAiB;EACxC,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B","sourcesContent":["/* ── page root ──────────────────────────────────────────── */\n.lp-root {\n  display: flex;\n  align-items: stretch;\n  justify-content: stretch;\n  height: 100vh;\n  width: 100vw;\n  background: #f0f4f8;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Inter\", \"Segoe UI\", sans-serif;\n}\n\n/* ── outer card wrapper ─────────────────────────────────── */\n.login-card-wrapper-section {\n  display: grid;\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n  border-radius: 28px;\n  background-color: #ffffff;\n  box-shadow: 0 12px 60px rgba(10, 30, 80, 0.10);\n  margin: 12px;\n  height: calc(100vh - 24px);\n  width: calc(100vw - 24px);\n}\n\n@media (min-width: 1024px) {\n  .login-card-wrapper-section {\n    grid-template-columns: 1.04fr 0.96fr;\n    border-radius: 28px;\n  }\n}\n\n/* ── Pallet logo — top right ────────────────────────────── */\n.lp-pallet-logo-wrap {\n  position: absolute;\n  top: 20px;\n  right: 24px;\n  z-index: 20;\n}\n\n.lp-pallet-logo {\n  height: 160px;\n  width: auto;\n  object-fit: contain;\n}\n\n/* ── left panel ─────────────────────────────────────────── */\n.lp-left {\n  display: none;\n  position: relative;\n  height: 100%;\n  overflow: hidden;\n  border-right: 1px solid #e8edf3;\n}\n\n@media (min-width: 1024px) {\n  .lp-left {\n    display: block;\n  }\n}\n\n/* ── carousel ───────────────────────────────────────────── */\n.lp-carousel {\n  position: absolute;\n  inset: 0;\n}\n\n.lp-slide {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  transition: opacity 0.9s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.lp-slide.active {\n  opacity: 1;\n}\n\n.lp-slide img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* ── dot indicators ─────────────────────────────────────── */\n.lp-dots {\n  position: absolute;\n  bottom: 1.5rem;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 8px;\n  z-index: 10;\n}\n\n.lp-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.5);\n  transition: background 0.3s, transform 0.3s;\n  cursor: pointer;\n  border: none;\n  padding: 0;\n}\n\n.lp-dot.active {\n  background: #fff;\n  transform: scale(1.35);\n}\n\n/* ── right panel ────────────────────────────────────────── */\n.lp-right {\n  display: flex;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n@media (min-width: 640px) {\n  .lp-right {\n    padding: 28px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .lp-right {\n    padding: 32px;\n  }\n}\n\n@media (min-width: 1280px) {\n  .lp-right {\n    padding: 40px;\n  }\n}\n\n/* ── form card — no nested card, just a max-width container ─ */\n.lp-form-card {\n  width: 100%;\n  max-width: 520px;\n  padding: 0;\n  color: #020617;\n  box-sizing: border-box;\n}\n\n/* ── badge ──────────────────────────────────────────────── */\n.lp-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  border-radius: 9999px;\n  border: 1px solid #dbeafe;\n  background-color: #eff6ff;\n  padding: 5px 14px 5px 8px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.22em;\n  color: #2a71ff;\n}\n\n.lp-badge-icon {\n  width: 22px;\n  height: 22px;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n/* ── heading ────────────────────────────────────────────── */\n.lp-heading {\n  margin: 12px 0 0 0;\n  font-size: 1.875rem;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  color: #020617;\n  display: flex;\n  justify-content: space-between;\n}\n\n/* ── info card ──────────────────────────────────────────── */\n.lp-info-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  border-radius: 26px;\n  border: 1px solid #dbeafe;\n  background: linear-gradient(180deg, #eff6ff 0%, #ffffff 100%);\n  padding: 16px;\n  box-shadow:\n    0 1px 3px rgba(0, 0, 0, 0.1),\n    0 1px 2px -1px rgba(0, 0, 0, 0.1);\n  /* margin-top: 32px; */\n  margin-bottom: 20px;\n}\n\n.lp-info-icon {\n  display: flex;\n  height: 48px;\n  width: 48px;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  border-radius: 16px;\n  background-color: #ffffff;\n  color: #2a71ff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.lp-info-brand {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.2em;\n  color: #2a71ff;\n  margin: 0 0 8px 0;\n}\n\n.lp-info-desc {\n  font-size: 14px;\n  line-height: 1.625;\n  color: #475569;\n  margin: 0;\n}\n\n/* ── idle logout banner ─────────────────────────────────── */\n.lp-idle-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  background: #eef3ff;\n  border: 1px solid #c5d4f0;\n  border-radius: 8px;\n  padding: 10px 14px;\n  margin-bottom: 18px;\n  font-size: 12px;\n  color: #3b63b8;\n}\n\n.lp-idle-icon {\n  flex-shrink: 0;\n  font-size: 16px !important;\n  margin-top: 1px;\n}\n\n/* ── form ───────────────────────────────────────────────── */\n.lp-form {\n  display: flex;\n  flex-direction: column;\n  margin-top: 32px;\n  gap: 0;\n}\n\n/* ── field labels ───────────────────────────────────────── */\n.lp-field-label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.2em;\n  color: #94a3b8;\n}\n\n/* ── mobile input wrapper ───────────────────────────────── */\n.lp-input-wrap {\n  display: flex;\n  align-items: stretch;\n  gap: 0;\n  border-radius: 24px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  padding: 0 16px 0 0;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  margin-bottom: 20px;\n  transition: border-color 0.15s, box-shadow 0.15s;\n  overflow: visible;\n}\n\n.lp-input-wrap:focus-within {\n  border-color: #2a71ff;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);\n}\n\n.lp-input-wrap .lp-input {\n  padding: 12px 0 12px 10px;\n  align-self: center;\n}\n\n.lp-input {\n  flex: 1;\n  border: none;\n  outline: none;\n  background: transparent;\n  padding: 4px 0;\n  height: 30px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #0f172a;\n  min-width: 0;\n}\n\n.lp-input::placeholder {\n  color: #94a3b8;\n  font-weight: 400;\n}\n\n/* hide number spinners */\n.lp-input::-webkit-outer-spin-button,\n.lp-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.lp-input[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n/* ── PIN input (full-width, no icon wrapper) ────────────── */\n.lp-pin-wrap {\n  display: flex;\n  align-items: center;\n  border-radius: 24px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  padding: 0 16px;\n  height: 56px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  margin-bottom: 8px;\n  transition:\n    border-color 0.15s,\n    box-shadow 0.15s;\n}\n\n.lp-pin-wrap:focus-within {\n  border-color: #2a71ff;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);\n}\n\n.lp-eye-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  color: #94a3b8;\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n/* ── forgot pin ─────────────────────────────────────────── */\n.lp-forgot {\n  margin: 4px 0 20px 0;\n}\n\n.lp-forgot span {\n  font-size: 14px;\n  font-weight: 700;\n  color: #2a71ff;\n  cursor: pointer;\n  transition: color 0.15s;\n}\n\n.lp-forgot span:hover {\n  color: #155eef;\n}\n\n/* ── submit button ──────────────────────────────────────── */\n.lp-submit-btn {\n  width: 100%;\n  height: 56px;\n  background: #2a71ff;\n  border: none;\n  border-radius: 24px;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  box-shadow: 0 22px 50px rgba(42, 113, 255, 0.35);\n  transition:\n    background 0.15s,\n    opacity 0.15s;\n}\n\n.lp-submit-btn:hover:not(:disabled) {\n  background: #155eef;\n}\n\n.lp-submit-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* ── reset pin panel ────────────────────────────────────── */\n.lp-back-btn {\n  /* Flexbox layout */\n  display: flex;\n\n  /* Sizing */\n  height: 2.75rem; /* 44px */\n  width: 2.75rem; /* 44px */\n\n  /* Flex alignment */\n  align-items: center;\n  justify-content: center;\n\n  /* Border radius */\n  border-radius: 1rem; /* 16px - rounded-2xl */\n\n  /* Border */\n  border: 1px solid #e2e8f0; /* slate-200 */\n\n  /* Background */\n  background-color: #ffffff; /* white */\n\n  /* Text/icon color */\n  color: #475569; /* slate-600 */\n\n  /* Transition */\n  transition: all 0.2s ease-in-out;\n\n  /* Remove default button styles */\n  cursor: pointer;\n\n  /* Optional: remove default focus outline (add custom one for accessibility) */\n  outline: none;\n}\n\n.lp-back-btn:hover {\n  border-color: #cbd5e1; /* slate-300 */\n  color: #0f172a;\n}\n\n.lp-reset-heading {\n  font-size: 1.6rem;\n  font-weight: 800;\n  color: #111827;\n  margin: 0 0 20px 0;\n}\n\n/* ── loading gif ────────────────────────────────────────── */\n.pos-gif-box {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background: #fff;\n}\n\n/* ── active button color ────────────────────────────────── */\n.changeBtnColor {\n  background-color: #2a71ff;\n}\n\n.move-back-button {\n  display: flex;\n  height: 2.75rem;\n  width: 2.75rem;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px; /* rounded-full */\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  color: #475569;\n  transition: all 0.2s ease-in-out;\n}\n\n.move-back-button:hover {\n  border-color: #cbd5e1;\n  color: #0f172a;\n}\n\n/* ── download section ───────────────────────────────────── */\n.lp-download-section {\n  margin-top: 20px;\n  padding-top: 18px;\n  border-top: 1px solid #f1f5f9;\n}\n\n.lp-download-title {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: #94a3b8;\n  margin: 0 0 10px 0;\n}\n\n.lp-store-links {\n  display: flex;\n  gap: 10px;\n}\n\n.lp-store-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 9px 16px;\n  border-radius: 24px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 600;\n  text-decoration: none;\n  transition: border-color 0.15s, background 0.15s, color 0.15s;\n  white-space: nowrap;\n}\n\n.lp-store-img {\n  width: 20px;\n  height: 20px;\n  object-fit: contain;\n  border-radius: 5px;\n  flex-shrink: 0;\n}\n\n.lp-store-btn:hover {\n  border-color: #2a71ff;\n  background: #eff6ff;\n  color: #2a71ff;\n}\n\n/* ── register row ───────────────────────────────────────── */\n.lp-register-row {\n  margin-top: 14px;\n  font-size: 13px;\n  color: #64748b;\n}\n\n.lp-register-link {\n  font-weight: 700;\n  color: #2a71ff;\n  text-decoration: none;\n  transition: color 0.15s;\n}\n\n.lp-register-link:hover {\n  color: #155eef;\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
